'use client';

import { useState } from 'react';
import styles from './BrowsePlansCta.module.scss';
import LeaveConversationModal from './LeaveConversationModal';
import UILink from './ui/UILink';

export default function BrowsePlansCta() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className={`${styles.container} browse-plans-cta`}>
      <p className={styles.text}>
        The ALEX recommendation is completely optional. <br />
        You can{' '}
        <UILink
          textType="body"
          size="large"
          label="browse plans in your area"
          onClick={() => setIsModalOpen(true)}
        />{' '}
        at any time.
      </p>
      <LeaveConversationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
}
